import { useState } from 'react';
import { FaCheck, FaTimes, FaQuestion, FaPlus } from 'react-icons/fa';

const RSVP = () => {
  const [formData, setFormData] = useState({
    name: '',
    attendance: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [companions, setCompanions] = useState([]);
  const [companionInput, setCompanionInput] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const addCompanion = () => {
    const trimmedInput = companionInput.trim();
    if (trimmedInput && !companions.includes(trimmedInput)) {
      setCompanions(prev => [...prev, trimmedInput]);
      setCompanionInput('');
    }
  };

  const removeCompanion = (companionToRemove) => {
    setCompanions(prev => prev.filter(companion => companion !== companionToRemove));
  };

  const handleCompanionKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addCompanion();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.name && formData.attendance) {
      setSubmitted(true);
      // Here you would typically send the data to a server
      // Include companions in the submission
      console.log({ ...formData, companions });
      setFormData({ name: '', attendance: '', message: '' });
      setCompanions([]);
    }
  };

  return (
    <section className="py-16 px-4 bg-rose-50">
      <div className="max-w-2xl mx-auto">
        <h2 className="font-great-vibes text-4xl text-center text-rose-600 mb-8">Confirmación de asistencia</h2>

        <p class="text-gray-700 mb-6">Te agradeceríamos que confirmases tu asistencia lo antes posible (tanto si vienes como si no). <br></br> <br></br> ¡No te olvides de anotar también a tus acompañantes!</p>
        
        <div className="bg-white p-6 rounded-lg shadow-md">
          {submitted && (
            <div className="mb-6 p-4 bg-green-100 text-green-700 rounded-lg">
              ¡Gracias por la confirmación!
            </div>
          )}
          
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="name" className="block text-gray-700 mb-2">Tu nombre</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-400 focus:border-transparent"
                required
              />
            </div>
            
            <div>
              <label htmlFor="companionName" className="block text-gray-700 mb-2">Tus acompañantes (Opcional)</label>
              <div className="flex flex-start gap-2">
                <input
                  type="text"
                  id="companionName"
                  name="companionName"
                  value={companionInput}
                  onChange={(e) => setCompanionInput(e.target.value)}
                  onKeyPress={handleCompanionKeyPress}
                  className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-400 focus:border-transparent"
                />
                <button
                  type="button"
                  onClick={addCompanion}
                  className="px-4 py-2 bg-rose-600 text-white rounded-lg hover:bg-rose-700 transition-colors flex items-center gap-1"
                >
                  <FaPlus /> Añadir
                </button>
              </div>

              {companions.length > 0 && (
                <div className="mt-3 space-y-2">
                  {companions.map((companion, index) => (
                    <div
                      key={index}
                      className="flex items-center justify-between bg-rose-100 px-4 py-2 rounded-lg"
                    >
                      <span className="text-gray-700">{companion}</span>
                      <button
                        type="button"
                        onClick={() => removeCompanion(companion)}
                        className="text-rose-600 hover:text-rose-800 transition-colors"
                        aria-label="Eliminar acompañante"
                      >
                        <FaTimes />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
            
            <div>
              <label className="block text-gray-700 mb-2">Pre-boda viernes 11 de Septiembre</label>
              <div className="flex flex-wrap gap-4">
                {[
                  { value: 'Sí asistiré', icon: <FaCheck className="mr-1" /> },
                  { value: 'Lo siento pero no acudiré', icon: <FaTimes className="mr-1" /> },
                  { value: 'Estoy en duda', icon: <FaQuestion className="mr-1" /> }
                ].map((option) => (
                  <label key={option.value} className="flex items-center">
                    <input
                      type="radio"
                      name="prewedding_attendance"
                      value={option.value}
                      checked={formData.prewedding_attendance === option.value}
                      onChange={handleChange}
                      className="mr-2 text-rose-600 focus:ring-rose-500 cursor-pointer"
                      required
                    />
                    <span className="flex items-center cursor-pointer">
                      {option.icon} {option.value}
                    </span>
                  </label>
                ))}
              </div>
            </div>

            <div>
              <label className="block text-gray-700 mb-2">Boda sábado 12 de Septiembre</label>
              <div className="flex flex-wrap gap-4">
                {[
                  { value: 'Sí asistiré', icon: <FaCheck className="mr-1" /> },
                  { value: 'Lo siento pero no acudiré', icon: <FaTimes className="mr-1" /> },
                  { value: 'Estoy en duda', icon: <FaQuestion className="mr-1" /> }
                ].map((option) => (
                  <label key={option.value} className="flex items-center">
                    <input
                      type="radio"
                      name="wedding_attendance"
                      value={option.value}
                      checked={formData.wedding_attendance === option.value}
                      onChange={handleChange}
                      className="mr-2 text-rose-600 focus:ring-rose-500 cursor-pointer"
                      required
                    />
                    <span className="flex items-center cursor-pointer">
                      {option.icon} {option.value}
                    </span>
                  </label>
                ))}
              </div>
            </div>

            <div>
              <label className="block text-gray-700 mb-2">Brunch domingo 13 de Septiembre</label>
              <div className="flex flex-wrap gap-4">
                {[
                  { value: 'Sí asistiré', icon: <FaCheck className="mr-1" /> },
                  { value: 'Lo siento pero no acudiré', icon: <FaTimes className="mr-1" /> },
                  { value: 'Estoy en duda', icon: <FaQuestion className="mr-1" /> }
                ].map((option) => (
                  <label key={option.value} className="flex items-center">
                    <input
                      type="radio"
                      name="postwedding_attendance"
                      value={option.value}
                      checked={formData.postwedding_attendance === option.value}
                      onChange={handleChange}
                      className="mr-2 text-rose-600 focus:ring-rose-500 cursor-pointer"
                      required
                    />
                    <span className="flex items-center cursor-pointer">
                      {option.icon} {option.value}
                    </span>
                  </label>
                ))}
              </div>
            </div>
            
            <div>
              <label htmlFor="phone" className="block text-gray-700 mb-2">Tu teléfono (Opcional)</label>
              <input
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-400 focus:border-transparent"
              ></input>
            </div>

            <div>
              <label htmlFor="message" className="block text-gray-700 mb-2">Un mensajito cariñoso (Opcional)</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="3"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-rose-400 focus:border-transparent"
              ></textarea>
            </div>
            
            <button
              type="submit"
              className="w-full py-3 bg-rose-600 text-white rounded-lg hover:bg-rose-700 transition-colors shadow-md"
            >
              Enviar confirmación
            </button>
          </form>
        </div>

        <p class="text-gray-500 mt-4 mb-4"> Si cuando se vaya acercando la fecha, hay cambios en la asistencia que nos enviaste, no te preocupes..puedes volver a enviarla usando este formulario nuevamente.</p>
      </div>
    </section>
  );
};

export default RSVP;